import React, { useState, useCallback } from 'react';
import {
  Button,
  ResourceList,
  ResourceItem,
  Text,
  Box,
  BlockStack,
  InlineStack,
} from '@shopify/polaris';
import { ResourcePicker } from '@shopify/app-bridge-react';

export function ProductPicker({ selectedProducts, onChange }) {
  const [isOpen, setIsOpen] = useState(false);
  const [products, setProducts] = useState([]);

  const handleSelection = useCallback(({ selection }) => {
    setIsOpen(false);
    setProducts(selection);
    onChange(selection.map(item => item.id));
  }, [onChange]);

  const toggleResourcePicker = useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);

  return (
    <>
      <BlockStack gap="400">
        <Button onClick={toggleResourcePicker}>
          Select Products
        </Button>
        
        {products.length > 0 && (
          <ResourceList
            resourceName={{ singular: 'Product', plural: 'Products' }}
            items={products}
            renderItem={(item) => {
              const { id, title, variants } = item;
              const price = variants[0].price;

              return (
                <ResourceItem
                  id={id}
                  accessibilityLabel={`View details for ${title}`}
                >
                  <InlineStack align="space-between">
                    <Box>
                      <Text variant="bodyMd" fontWeight="bold">{title}</Text>
                    </Box>
                    <Box>
                      <Text variant="bodyMd" color="subdued">${price}</Text>
                    </Box>
                  </InlineStack>
                </ResourceItem>
              );
            }}
          />
        )}
      </BlockStack>

      <ResourcePicker
        resourceType="Product"
        showVariants={false}
        open={isOpen}
        onSelection={handleSelection}
        onCancel={() => setIsOpen(false)}
      />
    </>
  );
} 